import { gql } from '@apollo/client';

const GOAL = `#graphql
  name
  timeHorizon
  targetAmountCents
  householdClientGroup { id name }
`;

const ACCOUNT = `#graphql
  type
  applyForGovFunds
  jurisdiction
  sourceOfFunds
  repCode { code }
  user { physicalAddress { country city province streetName postal unitNumber houseNumber neighborhood } maritalStatus countryOfTaxResidence }
  baseCurrency
  availableCurrencies
`;

const ENTITY = `#graphql
  firstName
  middleName
  lastName
  primaryEmail
  phone
  dateOfBirth
  language
  preferredMethodOfCommunication
  inProvinceSince
  gender
  physicalAddress { country city province streetName postal unitNumber houseNumber neighborhood }
`;

const enumerateCustomFieldsQuery = (fields?: string[]) => {
  if (!fields) return '';
  return `
    customFields(keys: ${JSON.stringify(fields)}) {
      key
      value
      customField { id translatedName { en fr } translatedDescription{ en fr} type format}
      selectedOptions { value displayText { en fr } }
    }
  `;
};

export const FETCH_USER_CUSTOM_FIELDS = (derivedCustomFields?: string[], enableCustodianCustomFields?: boolean) => gql`
  query fetchUserCustomFields($id: ObjectID!) {
    fetch:fetchUser(userId: $id) {
      object:user {
        id
        ${enumerateCustomFieldsQuery(derivedCustomFields)}
        ${enableCustodianCustomFields ? 'custodianCustomFields { key value }' : ''}
        ${ENTITY}
      }
    }
  }
`;

export const FETCH_GOAL_CUSTOM_FIELDS = (derivedCustomFields?: string[], _enableCustodianCustomFields?: any) => gql`
  query fetchGoalCustomFields($id: ObjectID!) {
    fetch:fetchGoal(goalId: $id) {
      object:goal {
        id
        ${enumerateCustomFieldsQuery(derivedCustomFields)}
        ${GOAL}
      }
    }
  }
`;

export const FETCH_ACCOUNT_CUSTOM_FIELDS = (derivedCustomFields?: string[], enableCustodianCustomFields?: boolean, permissions?: string[]) => gql`
  query fetchAccountCustomFields($id: ObjectID!) {
    fetch:fetchAccount(accountId: $id) {
      object:account {
        id
        ${enumerateCustomFieldsQuery(derivedCustomFields)}
        ${enableCustodianCustomFields ? 'custodianCustomFields { key value }' : ''}
        ${ACCOUNT}
      }
    }
  }
`;

export const UPDATE_USER_CUSTOM_FIELDS = gql`
  mutation updateUserCustomFields($id: ID!, $newCustomFields: [CustomFieldInput]!) {
    updateUser(input: { userId: $id, customFields: $newCustomFields }) {
      user {
        id
      }
    }
  }
`;

export const UPDATE_GOAL_CUSTOM_FIELDS = gql`
  mutation updateGoalCustomFields($id: ObjectID!, $newCustomFields: [CustomFieldInput]!) {
    updateGoal(input: { goalId: $id, customFields: $newCustomFields }) {
      goal {
        id
      }
    }
  }
`;

export const UPDATE_ACCOUNT_CUSTOM_FIELDS = gql`
  mutation updateAccountCustomFields($id: ObjectID!, $newCustomFields: [CustomFieldInput]!) {
    updateAccount(input: { accountId: $id, customFields: $newCustomFields }) {
      account {
        id
      }
    }
  }
`;

export const UPDATE_CUSTODIAN_CUSTOM_FIELDS = gql`
  mutation UpdateCustodianCustomFields($input: UpdateCustodianCustomFieldsInput!) {
    updateCustodianCustomFields(input: $input) {
      custodianCustomFields {
        key
        value
      }
    }
  }
`;
